// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Erjo","footer":"ModalCreateQualiphyProcedure_footer__2E6EE","additionData":"ModalCreateQualiphyProcedure_additionData__UrdrR"};